import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LegalLinesBody from '../../components/LegalPage/LegalLinesBody'
import LegalPageLayout from '../../components/LegalPage/LegalPageLayout'
import { parseLegalTextLines } from '../../utils/parseLegalText'
import { applyLandingSeo } from '../Landing/landingUtils'
import termsRaw from '../../../public/terms/SpectrAI Terms of Service.txt?raw'

const TERMS_LINES = parseLegalTextLines(termsRaw)

function PublicOfferPage() {
  const { t } = useTranslation()

  useEffect(() => {
    applyLandingSeo({
      page: 'landing',
      title: t('publicOffer.seoTitle'),
      description: t('publicOffer.seoDescription'),
      path: '/public-offer',
    })
  }, [t])

  return (
    <LegalPageLayout>
      <LegalLinesBody lines={TERMS_LINES} />
    </LegalPageLayout>
  )
}

export default PublicOfferPage
